export default __webpack_public_path__ + "static/27-662210bceafeff19b22b33286b51115b.png";